// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {
  getMessaging,
  getToken,
  onMessage,
  NotificationPayload,
} from "firebase/messaging";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDHb6cpAPTVFjUfJJ4z2c34uH04HZOULkg",
  authDomain: "sehatechllc-e8aa2.firebaseapp.com",
  projectId: "sehatechllc-e8aa2",
  storageBucket: "sehatechllc-e8aa2.appspot.com",
  messagingSenderId: "830047792855",
  appId: "1:830047792855:web:b7ce3c161d1050fcf68a92",
  measurementId: "G-QSJ4N8G0RY",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);
const analytics = getAnalytics(app);
export const storage = getStorage(app);

export const getTokenByUser = (setTokenFound) => {
  return getToken(messaging, {
    vapidKey:
      "BIci99sjQVe-X36Mz3mL3mMIRrmOzw4rj0B3VvQkjd8v6r0DX-76XhpSba-nuArd910EhGlRqyvmZ6TqnTSYKwA",
  })
    .then((currentToken) => {
      let token;
      if (currentToken) {
        console.log("current token for client: ", currentToken);
        token = currentToken;
        setTokenFound(true);
        return token;
        // Track the token -> client mapping, by sending to backend server
        // show on the UI that permission is secured
      } else {
        console.log(
          "No registration token available. Request permission to generate one."
        );
        setTokenFound(false);
        // shows on the UI that permission is required
      }
    })
    .catch((err) => {
      console.log("An error occurred while retrieving token. ", err);
      // catch error while creating client token
    });
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    console.log("IM IN THE PROMISE");
    onMessage(messaging, (payload) => {
      console.log(payload);
      resolve(payload);
    });
  });